import React from "react";
import { useNavigate } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import { appConfig } from "./utils/configs";
import { Routes } from "./utils/constants";

interface Auth0ProviderWithHistoryProps {
  children: React.ReactNode;
}

const Auth0ProviderWithHistory: React.FC<Auth0ProviderWithHistoryProps> = ({
  children,
}) => {
  const navigate = useNavigate();
  const domain = appConfig.API_URL;
  const clientId = appConfig.SPA_CLIENT_ID;

  const onRedirectCallback = (appState: any) => {
    navigate(appState?.returnTo || Routes.USER);
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: `${window.location.origin}${Routes.USER}`,
        audience: appConfig.AUTH0_AUDIENCE,
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
